export default __webpack_public_path__ + "img/copy-paste.539aead.svg";